<mat-dialog-content class="p-0">
  <p class="text-2xl mb-4">{{data.title}}</p>
  @if (isTypeIncluded(RadioModalDataType.Radio)) {
    <mat-radio-group aria-labelledby="group-label" class="radio-group" [(ngModel)]="selectedOption"
      >
      @for (radioData of data.options; track radioData) {
        <mat-radio-button class="mat-radio-button" [value]="radioData.value">
          {{ radioData.name }}
        </mat-radio-button>
      }
    </mat-radio-group>
  }
  @if (isTypeIncluded(RadioModalDataType.BetweenDates)) {
    <div>
      <div class="flex flex-row">
        <mat-form-field class="flex-auto gt-xs:pr-3" appearance="fill">
          <mat-label>Datas</mat-label>
          <mat-date-range-input [rangePicker]="dateRangePicker">
            <input matStartDate placeholder="Data de início" [(ngModel)]="startDate">
            <input matEndDate placeholder="Data final" [(ngModel)]="endDate">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
        </mat-form-field>
      </div>
    </div>
  }
  @if (isTypeIncluded(RadioModalDataType.Checkbox)) {
    <div>
      @for (option of data.options; track option; let i = $index) {
        <div>
          <mat-checkbox [(ngModel)]="selectedOptions[option.value]" [value]="option.value.toString()">
            {{ option.name }}
          </mat-checkbox>
        </div>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-stroked-button [mat-dialog-close]="false">Cancelar</button>
  <button mat-flat-button [color]="'primary'" (click)="confirmSelection()">Ok</button>
</mat-dialog-actions>
